export default __webpack_public_path__ + "static/media/ZW.5960b9c6.svg";